document.addEventListener('DOMContentLoaded', () => {
    // 关闭弹窗
    $(document).on('click', function (event) {
        if (!$(event.target).closest('.form-success-window').length) {
            $('.form-success-window').hide();
        }
    });
});